const UINT32_RANGE = 0x1_0000_0000;

export const normalizeSeed = (seed: number): number => {
  const normalized = seed >>> 0;
  return normalized === 0 ? 0x6d2b79f5 : normalized;
};

export const nextRandom = (state: number): { readonly state: number; readonly value: number } => {
  let next = normalizeSeed(state);
  next ^= next << 13;
  next ^= next >>> 17;
  next ^= next << 5;
  next >>>= 0;
  return { state: next, value: next / UINT32_RANGE };
};

export const randomInt = (state: number, min: number, maxInclusive: number): { readonly state: number; readonly value: number } => {
  const next = nextRandom(state);
  const value = min + Math.floor(next.value * (maxInclusive - min + 1));
  return { state: next.state, value };
};
